import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles, Box, Typography, Grid } from '@material-ui/core';
import { retrieveContentfulImage } from '../../common/image.js';
import clsx from 'clsx';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    quoteMb: {
      marginBottom: theme.spacing(2)
    },
    testimonialText: {
      fontWeight: "400",
      fontSize: theme.spacing(2.25),
      lineHeight: "27px"
    },
    testimonialTextOuter: {
      marginLeft: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      borderLeft: "2px solid #C4C4C4"
    },
    testimonialDetail: {
      marginTop: theme.spacing(3)
    },
    testimonialDetailName: {
      fontSize: theme.spacing(1.75),
      fontWeight: 500,
      lineHeight: "21px",
      fontStyle: "italic"
    },
    testimonialDetailCountry: {
      fontSize: theme.spacing(1.75),
      fontWeight: 400,
      lineHeight: "21px",
      fontStyle: "italic"
    },
    leftPadd: _defineProperty({
      paddingLeft: theme.spacing(4.75)
    }, theme.breakpoints.down("sm"), {
      paddingLeft: theme.spacing(0)
    }),
    avatarImg: {
      width: theme.spacing(10),
      height: theme.spacing(10),
      borderRadius: "50%"
    },
    ml2: {
      marginLeft: theme.spacing(2)
    },
    rootBox: _defineProperty({
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      maxWidth: theme.spacing(70.5)
    }, theme.breakpoints.down("sm"), {
      marginBottom: theme.spacing(4)
    }),
    textFooter: {
      marginTop: "auto",
      paddingTop: theme.spacing(5)
    },
    pt2: {
      paddingTop: theme.spacing(2)
    }
  };
});
var Testimonial = function Testimonial(_ref) {
  var country = _ref.country,
    person = _ref.person,
    text = _ref.text,
    imageTitle = _ref.imageTitle,
    imageUrl = _ref.imageUrl,
    icon = _ref.icon;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(Box, {
    className: classes.rootBox
  }, icon && /*#__PURE__*/React__default.createElement(Box, {
    className: classes.quoteMb
  }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    src: retrieveContentfulImage(icon, {
      width: 65,
      height: 47,
      fit: "fill"
    }),
    alt: "quote icon"
  })), /*#__PURE__*/React__default.createElement(Box, {
    className: classes.testimonialTextOuter
  }, /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.testimonialText
  }, text)), /*#__PURE__*/React__default.createElement(Box, {
    className: clsx(classes.textFooter, classes.leftPadd)
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    wrap: "nowrap"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    src: retrieveContentfulImage(imageUrl, {
      width: 240,
      height: 240,
      fit: "fill"
    }),
    className: classes.avatarImg,
    alt: imageTitle || "avatar"
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: clsx(classes.ml2, classes.pt2)
  }, /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.testimonialDetailName
  }, person), /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.testimonialDetailCountry
  }, country)))));
};
Testimonial.propTypes = {
  text: PropTypes__default.string,
  person: PropTypes__default.string,
  country: PropTypes__default.string,
  imageTitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  icon: PropTypes__default.string
};

export { Testimonial as default };
//# sourceMappingURL=Testimonial.js.map
